import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* fetchEmployeePlansInCurrentBoard() {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  yield put(actions.fetchEmployeePlans(pointSystem.id));

  let items;
  try {
    ({ items } = yield call(request, api.getEmployeePlans, pointSystem.id));
  } catch (error) {
    yield put(actions.fetchEmployeePlans.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.fetchEmployeePlans.success(pointSystem.id, items));
}

export function* createEmployeePlanInCurrentBoard(data = {}) {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  yield put(actions.createEmployeePlan(pointSystem.id, data));

  let item;
  try {
    ({ item } = yield call(request, api.createEmployeePlan, pointSystem.id, data));
  } catch (error) {
    yield put(actions.createEmployeePlan.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.createEmployeePlan.success(item));
  yield call(fetchEmployeePlansInCurrentBoard);
}

export function* updateEmployeePlan(id, data) {
  yield put(actions.updateEmployeePlan(id, data));

  let item;
  try {
    ({ item } = yield call(request, api.updateEmployeePlan, id, data));
  } catch (error) {
    yield put(actions.updateEmployeePlan.failure(id, error));
    return;
  }

  yield put(actions.updateEmployeePlan.success(item));
}

export function* deleteEmployeePlan(id) {
  yield put(actions.deleteEmployeePlan(id));

  let item;
  try {
    ({ item } = yield call(request, api.deleteEmployeePlan, id));
  } catch (error) {
    yield put(actions.deleteEmployeePlan.failure(id, error));
    return;
  }

  yield put(actions.deleteEmployeePlan.success(item));
  yield call(fetchEmployeePlansInCurrentBoard);
}

export default {
  fetchEmployeePlansInCurrentBoard,
  createEmployeePlanInCurrentBoard,
  updateEmployeePlan,
  deleteEmployeePlan,
};

